import { ThemeConfig } from 'antd';
import { redButtonTheme, yellowButtonTheme } from '../../theme';

export enum UpgradeState {
  default,
  awaitingConfirmation,
}

type PlanInfo = {
  title: string;
  theme?: ThemeConfig;
  price: string;
  planId?: string;
  features: PlanFeatures;
  buttonType: string;
  blurb?: string;
};

interface PlanFeatures {
  Essentials: {
    'Number of listens': string;
    'Number of giides': string;
    'Max length': string;
    'Multi-chapter': boolean;
    'Basic Analytics': boolean;
    'Closed Captions': boolean;
  };
  'Creator Tools': {
    'Giphy and Unsplash library': boolean;
    'Transcript Access and Editing': boolean;
    'Video download (coming soon!)': boolean;
  };
  Sharing: {
    Hosting: boolean;
    'Embed Code': boolean;
    'Library Page': boolean;
    'Custom Branding': boolean;
  };
  Support: {
    'Dedicated Customer Support': boolean;
    'Creation Services': boolean;
  };
}

export const plans: PlanInfo[] = [
  {
    title: 'Starter',
    price: '$29',
    theme: redButtonTheme,
    planId: process.env.REACT_APP_STARTER_PLAN_ID,
    features: {
      Essentials: {
        'Number of giides': '3 maximum',
        'Number of listens': 'Unlimited',
        'Max length': '40 minutes',
        'Multi-chapter': true,
        'Basic Analytics': true,
        'Closed Captions': true,
      },
      'Creator Tools': {
        'Transcript Access and Editing': true,
        'Video download (coming soon!)': true,
        'Giphy and Unsplash library': true,
      },
      Sharing: {
        Hosting: true,
        'Embed Code': false,
        'Library Page': false,
        'Custom Branding': false,
      },
      Support: {
        'Dedicated Customer Support': false,
        'Creation Services': false,
      },
    },
    buttonType: 'signup',
  },
  {
    title: 'Premium',
    price: '$99',
    theme: yellowButtonTheme,
    planId: process.env.REACT_APP_PREMIUM_PLAN_ID,
    features: {
      Essentials: {
        'Number of giides': '15 maximum',
        'Number of listens': 'Unlimited',
        'Max length': '40 minutes',
        'Multi-chapter': true,
        'Basic Analytics': true,
        'Closed Captions': true,
      },
      'Creator Tools': {
        'Transcript Access and Editing': true,
        'Video download (coming soon!)': true,
        'Giphy and Unsplash library': true,
      },
      Sharing: {
        Hosting: true,
        'Embed Code': false,
        'Library Page': false,
        'Custom Branding': false,
      },
      Support: {
        'Dedicated Customer Support': false,
        'Creation Services': false,
      },
    },
    buttonType: 'signup',
  },
  {
    title: 'Business',
    price: 'Custom',
    features: {
      Essentials: {
        'Number of giides': 'Unlimited',
        'Number of listens': 'Unlimited',
        'Max length': '40 minutes',
        'Multi-chapter': true,
        'Basic Analytics': true,
        'Closed Captions': true,
      },
      'Creator Tools': {
        'Transcript Access and Editing': true,
        'Video download (coming soon!)': true,
        'Giphy and Unsplash library': true,
      },
      Sharing: {
        Hosting: true,
        'Embed Code': true,
        'Library Page': true,
        'Custom Branding': true,
      },
      Support: {
        'Dedicated Customer Support': true,
        'Creation Services': true,
      },
    },
    buttonType: 'contact',
  },
];

export const featureCategories = plans[0].features;
